import { t } from "i18next";
import { TextArea } from "../../../../../components/deprecated/TextArea/TextArea";

import { CustomFieldDataOptions } from "../../../Property/Collections/PropertyCustomFieldData";
import { CustomFieldDataTypeHelper, DataEditorContext } from "./CustomFieldDataTypeHelper";
import styles from "./CustomFieldDateDataType.module.css";

export class CustomFieldTextDataType extends CustomFieldDataTypeHelper<string> {
  getDataEditor(
    data: any | undefined,
    options: CustomFieldDataOptions,
    context: DataEditorContext,
    setData: (data: string | undefined) => void
  ): JSX.Element {
    return (
      <TextArea
        className={styles.textInput}
        placeholder={t("main.enterText")}
        value={typeof data === "string" ? data : ""}
        onChange={(text) => setData(text)}
        width="100%"
        resize="vertical"
      />
    );
  }
  getStringRepresentation(data: any, options: CustomFieldDataOptions, context: DataEditorContext): string | Promise<string> {
    return data === undefined || data === null ? "" : "" + data;
  }
}
